import React, { createContext, useContext, useEffect, useState } from 'react';
import apiClient from '../api';

const AuthContext = createContext(null);

function normalizeRole(role) {
    if (!role) return null;
    return role.startsWith('ROLE_') ? role : `ROLE_${role.toUpperCase()}`;
}

export function AuthProvider({ children }) {
    const [user,   setUser]   = useState(null);
    const [player, setPlayer] = useState(null);
    const [team,   setTeam]   = useState(null);
    const [loading, setLoading] = useState(true);

    const refreshMe = async () => {
        try {
            // /players/me ya valida el token y devuelve rol + teamId:
            // una sola llamada reemplaza /auth/me + /players/me
            const [playerRes, authRes] = await Promise.all([
                apiClient.get('/players/me'),
                apiClient.get('/auth/me'),
            ]);

            const playerData = playerRes.data;
            const authData   = authRes.data;

            setUser({
                email: authData.email,
                roles: Array.isArray(authData.roles)
                    ? authData.roles
                    : (authData.roles ? [authData.roles] : []),
            });

            const normalizedPlayer = { ...playerData, role: normalizeRole(playerData.role) };
            setPlayer(normalizedPlayer);

            const teamId = playerData.teamId ?? playerData.player?.teamId;
            if (teamId) {
                const teamRes = await apiClient.get(`/teams/${teamId}`);
                setTeam(teamRes.data);
            } else {
                setTeam(null);
            }
        } catch (e) {
            setUser(null);
            setPlayer(null);
            setTeam(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refreshMe();
    }, []);

    const signIn = async (email, password) => {
        await apiClient.post('/login', { email, password }, { withCredentials: true });
        await refreshMe();
    };

    const signOut = async () => {
        await apiClient.post('/auth/logout');
        setUser(null);
        setPlayer(null);
        setTeam(null);
    };

    return (
        <AuthContext.Provider value={{ user, player, team, loading, signIn, signOut, refreshMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
